// extracted by mini-css-extract-plugin
export default {"comming_soon":"CoomingSoon_comming_soon__x6iZ9","comming_soon_main":"CoomingSoon_comming_soon_main__ycsML","comming_soon_block":"CoomingSoon_comming_soon_block__SrlHC"};